/**
 * ¿Está el cobro de la cuota en la API? **No todavía**: contratar, cambiar el método de pago, pagar lo pendiente,
 * añadir o quitar bloques, comprar extras, la recarga automática, la pausa y la baja esperan a la respuesta de la
 * asesoría fiscal sobre el IVA y Stripe Tax (G92) y a la entrega de Stripe de Planes y Suscripciones. Sus operaciones
 * responden 404 hasta entonces, así que la pantalla no enseña esos botones y no las llama.
 *
 * Cuando lleguen, basta con poner `true`: las acciones ya están programadas contra el contrato (`api/ops/plan.ts`), con
 * los dos pasos en el momento en la baja (`x-two-factor: session`, G116). Faltarán aún el catálogo (`getCatalog`:
 * nombres, precios y «Añade a tu plan», P0-7) y los paquetes de WhatsApp (1.16), que no están programados en el panel.
 */
export const COBRO_DISPONIBLE: boolean = false;

/** Lo que dice la pantalla al propietario mientras el cobro no está (sin fechas: no hay una decidida). */
export const TEXTO_SIN_COBRO = 'Contratar y pagar desde el panel llega pronto. Mientras tanto, si necesitas algo de tu plan, escríbenos.';
